import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpSupportRoutingModule } from './sp-support-routing.module';
import { SpSupportComponent } from './sp-support.component';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SpSupportRoutingModule,
    TableModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    SharedModule
    
  ],
  declarations: [
    SpSupportComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SpSupportModule { }
